

import { Observable } from 'rxjs';
import { Parameter } from '../../../../../@core/interfaces/common/parameter';



export interface  InventoryPurchaseDetailsParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface  InventoryPurchaseDetails {
  id?;
  
  storeId?:any;
  
  medicineName?;
  
  storestorePurchaseId?:any;
  
  storePurchaseId?:any;

  storerowId: any;
  
  storegrnId?: string;
  
  storeItemId: string;
  
  storebatchnum: string;
  
  storeexpiryDate: Date;
  
  storerackId?: string;
  
  storeboxNo: string;
  
  storeunits: Number; 
  
  storenoofqty: Number; 
  
  storepriceperpack: Number;
  
  storemrpperpack: Number;
  storesellPerPrice?: Number;
  storefreestrips: Number; 
  
  storediscountPer: Number; 
  
  storediscountValue: Number;
  
  storehsnCode: string;
  
  storegstTotalPer: any;
  
  storeigstPer: Number; 
  
  storecgstPer: Number;
  
  storesgstPer: Number;
  
  storegstTotalValue: Number;
  
  storeigstValue: Number;
  
  storecgstValue: Number;
  
  storesgstValue: Number;
  
  storetotalPrice: Number; 
  
  storeupcEanCode: string; 
  
  storetaxableAmount: Number;
  
  storepayableAmount: Number;
    
  tenantId: string;
  
  branchId?: string;
 
  storeSellPerPricepack:any;

  warehouseId:any;

    parameters?:  InventoryPurchaseDetailsParameter[];
    links?: any;
}

export abstract class  InventoryPurchaseDetailsData {
  
  abstract list(url: string): Observable< InventoryPurchaseDetails[]>;
  abstract create(url: string,data:  InventoryPurchaseDetails): Observable<any>;
  abstract update(url: string,data:  InventoryPurchaseDetails): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
